import { useEffect, useRef, useState } from 'react';
import { Button, Dialog, Grid, TextField, Typography, Rating, Box, Avatar, Tooltip, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { AppActions } from 'src/store/AppReducer';
import EmployeeSelectDropdown from '../componets/EmployeeSelect';
import { AddFeedback } from '../interfaces/addFeedback';
import ProjectSelectDropdown from '../componets/projectSelect';
import '../Feedback.css';
import CategorySelectDropdown from '../componets/CategorySelect';
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import './feedbackModal.css';
interface addFeedbackModalProps {
  open: boolean;
  toggle: () => void;
  onSave: (data: AddFeedback) => void;
  editData?: AddFeedback | null;
  tabValue?: any
}

const FeedbackModal: React.FC<addFeedbackModalProps> = ({ open, toggle, onSave, editData, tabValue }) => {
  const initialValues = {
    receiverId: null,
    projectId: null,
    categoryId: null,
    rating: 0,
    description: '',
  } as AddFeedback;

  const dispatch = useDispatch();
  const [feedbackValues, setFeedbackValues] = useState(initialValues);
  const { register, handleSubmit, reset, setValue, formState: { errors } } = useForm<AddFeedback>();
  const [preview, setPreview] = useState<boolean>(false);
  const [resourceData, SetResourceData] = useState<any>();
  const [starError, setStarError] = useState<boolean>(false);
  const descriptionRef = useRef('');
  useEffect(() => {
    if (open) {
      const dataToUse = editData || initialValues;
      reset(dataToUse);
      setFeedbackValues(dataToUse);
      console.log("dataToUse", dataToUse)
      editData ? setPreview(true) : setPreview(false)
    }
  }, [open, editData]);

  const onSubmit = (data: AddFeedback) => {

    if (preview) {
      if (data.rating > 0) {
        setStarError(false)
        dispatch(AppActions.showLoader());
        setFeedbackValues(initialValues);
        dispatch(AppActions.hideLoader());
        onSave(data);

      } else {
        setStarError(true)
      }
    } else {
      setPreview(true)
      setStarError(false)
    }
  };
  const guidelinesHTML = `
  <h4 style="margin-top: 0;">Guidelines to provide feedback</h4>
  <ul style="margin: 0; padding-left: 1.5rem; font-size: 12px;">
      <li><strong>Specificity:</strong> Be specific and provide concrete examples to support your points.</li>
      <li><strong>Constructive Criticism:</strong> Focus on the behavior and its impact, not on personal attacks.</li>
      <li><strong>Focus on Improvement:</strong> Frame negative feedback constructively, focusing on how the employee can improve.</li>
      <li><strong>Regular Feedback:</strong> Provide regular feedback, both positive and negative, to ensure employees are aware of their strengths and areas for development.</li>
      <li><strong>Documentation:</strong> Keep records of all feedback provided, both positive and negative.</li>
  </ul>
  <p style="margin-top: 1rem; font-size: 12px;">
      By using these categories, you can ensure that your feedback is:
  </p>
  <ul style="margin: 0; padding-left: 1.5rem; font-size: 12px;">
      <li><strong>Objective:</strong> Based on observable behaviors and measurable outcomes.</li>
      <li><strong>Consistent:</strong> Applied consistently across all employees.</li>
      <li><strong>Fair:</strong> Provides a fair and equitable assessment of employee performance.</li>
      <li><strong>Actionable:</strong> Helps employees understand how to improve their performance.</li>
  </ul>
`;

  return (
    <Dialog
      open={open}
      maxWidth="sm"
      fullWidth
      scroll="paper"
      onClose={toggle}
      className='feedback-modal'
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container >

          <Grid item xs={12} display="flex" justifyContent="space-between" sx={{ p: 3, pb: 2 }}>
            <Typography style={{ fontSize: '17px', fontWeight: '600' }} >{preview ? 'Preview' : 'Add Feedback'}
              <Tooltip id="guideline-tp" title={
                <Typography component="div" dangerouslySetInnerHTML={{ __html: guidelinesHTML }} />
              }>
                <IconButton>
                  <InfoOutlinedIcon sx={{ fontSize: 15 }} />
                </IconButton>
              </Tooltip>
            </Typography>
            <CloseIcon onClick={toggle} sx={{ cursor: 'pointer', fontSize: '17px', }} />
          </Grid>


          <Grid item xs={12} sx={{ p: 3, pt: 0 }} gap={1}>

            {!preview && (
              <Grid item xs={12} pb="1rem">
                <Typography fontWeight="light" variant="h5" className="input-lable">
                  Resource
                </Typography>
                <EmployeeSelectDropdown
                  {...register('receiverId', { required: true })}
                  value={feedbackValues.receiverId}
                  onChange={(e: any) => {
                    setFeedbackValues(prev => ({ ...prev, receiverId: e.target.value }));
                    setValue('receiverId', e.target.value);

                  }}
                  getEmp={(e: any) => {
                    SetResourceData(e)
                  }}
                />
                {errors.receiverId && !feedbackValues.receiverId && (
                  <Typography sx={{ fontSize: '12px' }} color="error">Resource is required.</Typography>
                )}
              </Grid>

            )}


            {preview && (
              <Grid
                container
                direction="column"
                alignItems="center"
                spacing={2}

                pb="1rem"
              >
                <div>
                  {editData ? <Avatar
                    src={`data:image/jpeg;base64,${tabValue === 0 ? editData.senderImage : editData.receiverImage}`}
                    alt="gayan"
                    sx={{ width: 50, height: 50, borderRadius: 0 }}
                  /> : <Avatar
                    src="# "
                    alt="User"
                    sx={{ width: 50, height: 50, borderRadius: 0 }}
                  />}

                </div>
                <div>
                  <Typography sx={{ fontSize: '18px' }} fontWeight="bold" textAlign="center">
                    {editData ? tabValue === 0 ? editData.sender : editData.receiver : resourceData.name}
                  </Typography>
                </div>
                <div >
                  <Typography sx={{ fontSize: '13px' }} variant="subtitle1" textAlign="center">
                    {editData ? tabValue === 0 ? editData.senderDesignation : editData.receiverDesignation : resourceData.designation}
                  </Typography>
                </div>
                <div >
                  <Rating
                    sx={{ fontSize: '50px', marginTop: '8px' }}
                    value={feedbackValues.rating}
                    onChange={(e, value) => {
                      setFeedbackValues((prev) => ({ ...prev, rating: value || 0 }));
                      setValue('rating', value || 0);
                      setStarError(value > 0 ? false : true)
                    }}
                    className={`rating-component ${starError ? 'high-rating' : 'low-rating'}`}
                  />
                  {/* {starError && (
                  <Typography sx={{ fontSize: '12px' }} color="error">rating is required.</Typography>
                )} */}
                </div>
              </Grid>
            )}

            <Grid item xs={12} pb="1rem">
              <ProjectSelectDropdown
                {...register('projectId', { required: true })}
                value={feedbackValues.projectId}
                onChange={(e: any) => {
                  setFeedbackValues(prev => ({ ...prev, projectId: e.target.value }));
                  setValue('projectId', e.target.value);
                }}
              />
              {errors.projectId && !feedbackValues.projectId && (
                <Typography sx={{ fontSize: '12px' }} color="error" >Project is required.</Typography>
              )}
            </Grid>

            <Grid item xs={12} pb="1rem">
              <Typography fontWeight="light" variant="h5" className="input-lable" >
                Category
              </Typography>
              <CategorySelectDropdown
                {...register('categoryId', { required: true })}
                value={feedbackValues.categoryId}
                onChange={(e: any) => {
                  setFeedbackValues(prev => ({ ...prev, categoryId: e.target.value }));
                  setValue('categoryId', e.target.value);
                }}
              />
              {errors.categoryId && !feedbackValues.categoryId && (
                <Typography sx={{ fontSize: '12px' }} color="error" >Category is required.</Typography>
              )}
            </Grid>

            <Grid item xs={12} pb="1rem">
              <Typography variant="subtitle2" className="input-lable" >Incident</Typography>
              <TextField
                sx={{ mt: '4px' }}
                {...register('description', { required: true, maxLength: 500 })}
                value={feedbackValues.description}
                onChange={(e) => {
                  let value = e.target.value;
                  if (value.length > 500) {
                    value = value.slice(0, 500);
                  }
                  descriptionRef.current = value;

                  setFeedbackValues(prev => ({ ...prev, description: value }));
                  setValue('description', value);
                }}
                placeholder="Enter Incident"
                size="small"
                fullWidth
                multiline
                rows={3}
              />
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                {errors.description && !feedbackValues.description && (
                  <Typography sx={{ fontSize: '12px' }} color="error" >
                    Incident is required.
                  </Typography>
                )}
                 {(!errors.description || feedbackValues.description ) && (
                  <Typography sx={{ fontSize: '12px',color: 'transparent' }} color="error1" >
                    dfd
                  </Typography>
                )}
                <Typography variant="caption">
                {Math.min(feedbackValues?.description?.length || 0)}/500
                </Typography>
              </Box>

            </Grid>

            {preview && (

              <Grid item xs={12} pb="1rem" style={{ display: 'flex', alignItems: 'center' }}>
                <span style={{ whiteSpace: 'nowrap', color: 'rgba(98, 103, 253, 1)' }}>Note :</span>
                <span style={{ marginLeft: '0.5rem', fontSize: "14px" }}>Review thoroughly before submitting. Editable for 7 days afterward.</span>
              </Grid>

            )}

            <Grid item xs={12} display="flex" justifyContent="flex-end" mt={2}>
              <Button
                id="btn-onClose"
                sx={{
                  width: '10%',
                  fontWeight: 'normal',
                  background: '#F5F7FF',
                  fontSize: '13px'
                }}
                onClick={() => {
                  reset();
                  toggle();
                }}
              >
                Cancel
              </Button>
              <Button
                id="btn-onSubmit"
                sx={{
                  ml: 2,
                  width: '10%',
                  fontSize: '13px',
                  fontWeight: 'normal',
                  background: '#0069E4',
                  textTransform: 'capitalize'
                }}
                variant="contained"
                type="submit"
              >
                {preview ? 'Submit' : 'Preview'}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </Dialog>
  );
};

export default FeedbackModal;